import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readAllTenant, exportSelectAllMohs, exportDeleteMohs } from '../../../services';
import { scopeByTenant } from '../../../services/tenantScope';

import PbxContext from '../../../context/PbxContext';
import Loading from '../../../components/Loading/LoadingModule';
import './MohList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { hasFeature } from '../../../services/permissions';

function MohList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit } = getItensStateGlobal;

  const [loading, setLoading] = useState(true);
  const [mohs, setMohs] = useState([]);
  const [selectedMoh, setSelectedMoh] = useState(null);
  const [mohSelected, setMohSelected] = useState([]);
  const [deleting, setDeleting] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const history = useHistory();

  const fetchMohs = async (idtenant) => {
    try {
      const response = await exportSelectAllMohs();
      if (response && response.status === 200 && response.data) {
        setMohs(scopeByTenant(response.data, (moh) => moh.accountcode, idtenant));
      } else {
        console.error("Erro ao buscar músicas de espera:", response);
        setAlert({ show: true, type: 'danger', message: 'Não foi possível carregar as músicas de espera.' });
      }
    } catch (error) {
      console.error("Exceção ao buscar músicas de espera:", error);
      setAlert({ show: true, type: 'danger', message: 'Não foi possível carregar as músicas de espera.' });
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');

    const { user: { idtenant } } = dataUser;

    let tenantsFetched = await readAllTenant();
    tenantsFetched = scopeByTenant(tenantsFetched, (tenant) => tenant.short_name, idtenant);

    if (!tenantsFetched) return;

    await fetchMohs(idtenant);
    setLoading(false);
  }, [history]);

  const handleChangeSelectedMohs = (mohName) => {
    setMohSelected(mohName);
  };

  const handleClickDelete = () => {
    setAlert({ show: false, type: '', message: '' });
    setSelectedMoh(mohSelected);
    setShowConfirmDelete(true);
  };

  const confirmDelete = async () => {
    setShowConfirmDelete(false);
    setDeleting(true);

    try {
      const result = await exportDeleteMohs(selectedMoh);

      if (result.success) {
        setMohSelected([]);
        setSelectedMoh(null);
        const dataUser = accessLocalStorage.getUserLocalStorage();
        if (dataUser) await fetchMohs(dataUser.user.idtenant);
        setAlert({ show: true, type: 'success', message: 'Música de espera excluída com sucesso!' });
        return;
      }

      setAlert({ show: true, type: 'danger', message: result.error });
    } finally {
      setDeleting(false);
    }
  };

  const handleClickUpdate = () => {
    setItemsSelectedToEdit(mohSelected);
    history.push('/config/musica-de-espera/editar');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-list-container">
          <div className="moh-header">
            <div className="moh-title-wrapper">
              <div className="moh-title-left">
                <svg className="moh-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                </svg>
                <div>
                  <h1 className="moh-title">Músicas de Espera</h1>
                  <p className="moh-subtitle">Gerencie as músicas de espera do sistema</p>
                </div>
              </div>
              <div className="moh-actions">
                {hasFeature('config.moh', 'create') && (
                <Link to="/config/musica-de-espera/novo" className="btn-moh btn-new-moh">
                  <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                  Nova Música
                </Link>
                )}
                <button
                  className="btn-moh btn-edit-moh"
                  disabled={mohSelected.length === 0 || deleting}
                  onClick={handleClickUpdate}
                >
                  <FontAwesomeIcon icon={faPen} className="btn-icon" />
                  Editar
                </button>
                <button
                  className="btn-moh btn-delete-moh"
                  disabled={mohSelected.length === 0 || deleting}
                  onClick={handleClickDelete}
                >
                  <FontAwesomeIcon icon={faTrash} className="btn-icon" />
                  {deleting ? 'Excluindo...' : 'Excluir'}
                </button>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            {alert.show && (
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
                </div>
                <div className="alert-body">{alert.message}</div>
              </div>
            )}

            {showConfirmDelete && (
              <div className="alert-message alert-danger">
                <div className="alert-header">
                  <span>Atenção!</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setShowConfirmDelete(false)}>×</button>
                </div>
                <div className="alert-body">
                  Tem certeza que deseja excluir a música de espera <strong>{selectedMoh}</strong>?
                </div>
                <div className="alert-actions">
                  <button className="btn-alert btn-alert-confirm" onClick={confirmDelete}>
                    <FontAwesomeIcon icon={faTrash} />
                    Confirmar
                  </button>
                  <button className="btn-alert btn-alert-cancel" onClick={() => setShowConfirmDelete(false)}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="moh-table-wrapper">
            <table className="moh-table">
              <thead className="moh-table-header">
                <tr>
                  <th className="checkbox-cell"></th>
                  <th>Nome</th>
                  <th>Cliente</th>
                  <th>Modo</th>
                  <th>Ordenação</th>
                  <th>Arquivo/Diretório</th>
                </tr>
              </thead>
              <tbody>
              {mohs.length > 0 ? (
                mohs.filter((moh) => moh.name !== 'default').map((moh) => {
                  const { name, accountcode, mode, sort, directory, entry } = moh;
                  const displayPathFile = entry || directory ? (entry?.split('uploads')[1] || directory?.split('uploads')[1]) : '-';
                  return (
                    <tr key={name}>
                      <td className="checkbox-cell">
                        <input
                          name="moh-selected"
                          id={name}
                          type="radio"
                          value={name}
                          checked={mohSelected === name}
                          onChange={(e) => handleChangeSelectedMohs(e.target.value)}
                        />
                      </td>
                      <td>{name}</td>
                      <td>{accountcode}</td>
                      <td>{mode === 'files' ? 'Ler Pasta' : 'Música Única'}</td>
                      <td>{sort === 'name' ? 'Nome' : sort === 'random' ? 'Aleatório' : sort}</td>
                      <td>{displayPathFile}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" style={{textAlign: 'center'}}>Nenhuma música de espera encontrada</td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default MohList;
